import React, { memo, FC } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { profiles, fullboundProfileOptions } from "./defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { Image } from "cloudinary-react";
import { styled } from "@mui/material/styles";
import useFixedPanelProfileSelector from "./useFixedPanelProfileSelector";

const RowLayoutSpace = styled("div")(({ theme }) => ({
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
}));

const RowLayoutLeftDivide = styled("div")(({ theme }) => ({
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const FixedPanelProfiles: FC = () => {
  const {
    checkMark,
    checkMarkFullbound,
    variant,
    variantFullbound,
    handleClick,
    handleClickFullbound,
    isDirectGlaze,
    fullboundProfile,
    exactConfig,
    stilesRailsProfile
  } = useFixedPanelProfileSelector()

  return (
    <ReusableAccordian
      accordionName="stilesRailsProfile"
      heading={isDirectGlaze ? "Frame Profile" : "Stiles and Rails Profile"}
      secondaryHeading="Select profile"
      colOrRow="col"
    >
      <ColLayout>
        {isDirectGlaze ? (
          <RowLayout style={{ paddingBottom: 20 }}>
            {profiles.map((state) => (
              <div key={state.id} onClick={() => handleClick(state.label)}>
                <Choices
                  label={state.label}
                  variant={variant(state.label)}
                  checkMark={checkMark(state.label)}
                  wide={true}
                />
              </div>
            ))}
          </RowLayout>
        ) : (
          <RowLayout style={{ paddingBottom: 20 }}>
            <RowLayoutSpace>
              {fullboundProfileOptions.map((state) => (
                <div
                  key={state.id}
                  onClick={() => handleClickFullbound(state.label)}
                >
                  <Choices
                    label={state.label}
                    variant={variantFullbound(state.label)}
                    checkMark={checkMarkFullbound(state.label)}
                    wide={true}
                  />
                </div>
              ))}
            </RowLayoutSpace>

            <RowLayoutLeftDivide>
              {profiles.map((state) => (
                <div key={state.id} onClick={() => handleClick(state.label)}>
                  <Choices
                    label={state.label}
                    variant={variant(state.label)}
                    checkMark={checkMark(state.label)}
                    wide={true}
                  />
                </div>
              ))}
            </RowLayoutLeftDivide>
          </RowLayout>
        )}

        {exactConfig?.includes("Full Bound") &&
          stilesRailsProfile &&
          fullboundProfile && (
            <div style={{ height: 239 }}>
              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId={`Frame_Profile/Fixed_Panel/Full_Bound/${
                  exactConfig.includes("Outswing") ? "OS" : "IS"
                }_${fullboundProfile
                  ?.replace(" Profile", "")
                  .toUpperCase()}_${stilesRailsProfile?.toUpperCase()}_v2`}
              />
            </div>
          )}

        {stilesRailsProfile && exactConfig === "Direct Glaze" && (
          <div style={{ height: 192 }}>
            <Image
              cloudName="ag-millworks"
              secure="true"
              publicId={`Frame_Profile/Fixed_Panel/Direct_Glaze/${stilesRailsProfile?.toUpperCase()}_SQUARE`}
            />
          </div>
        )}
      </ColLayout>
    </ReusableAccordian>
  );
};

export default memo(FixedPanelProfiles);
